import * as convert from 'xml-js'

import ClubService from 'Services/club'
import CustomLinkService from 'Services/customlinks'
import UploadService from 'Services/upload'

import { toast } from 'react-toastify'
import { navigate } from 'raviger'

async function handleSaveCustomLinks(items, id) {
  const xmlOptions = { compact: true, ignoreComment: true, spaces: 4, ignoreAttributes: '<root>' }

  items.forEach(async item => {
    const result = convert.json2xml(
      JSON.stringify({
        team_open: item.team_open,
        team_age: item.team_age,
        team_gender: item.team_gender,
        team_level: item.team_level,
        team_season: item.team_season,
        team_zip: item.team_zip
      }),
      xmlOptions
    )

    const data = {
      clubimpact_id: id,
      icon: item.icon,
      shortname: item.shortName,
      longname: item.longName,
      url: item.url,
      costom_fields: result
    }

    await CustomLinkService.create({ data }).catch(err => toast.error(err))
  })
}

async function uploadImages(previewImages, clubData) {
  // Upload logo
  if (previewImages.imageHeader?.file) {
    const formData7 = new FormData()
    formData7.append('previewImagesHeader', previewImages?.imageHeader.file)
    formData7.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.imageHeader?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadHeader({ formData: formData7 })
    } catch (err) {
      toast.error(`Something went wrong when trying to upload the logo image: ${err.message}`)
      return false
    }
  }

  if (previewImages.image1?.file) {
    const formData1 = new FormData()
    formData1.append('resource', previewImages.image1.file)
    formData1.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image1.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData1 })
    } catch (err) {
      toast.error(`Something went wrong when trying to upload resource image #1: ${err.message}`)
      return false
    }
  }

  if (previewImages.image2?.file) {
    const formData2 = new FormData()
    formData2.append('resource', previewImages.image2.file)
    formData2.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image2?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData2 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #2: ${err.message}`)
      return false
    }
  }

  if (previewImages.image3?.file) {
    const formData3 = new FormData()
    formData3.append('resource', previewImages.image3.file)
    formData3.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image3?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData3 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #3: ${err.message}`)
      return false
    }
  }

  if (previewImages.image4?.file) {
    const formData4 = new FormData()
    formData4.append('resource', previewImages.image4.file)
    formData4.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image4?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData4 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #4: ${err.message}`)
      return false
    }
  }

  if (previewImages.image5?.file) {
    const formData5 = new FormData()
    formData5.append('resource', previewImages.image5.file)
    formData5.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image5?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData5 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #5: ${err.message}`)
      return false
    }
  }

  if (previewImages.image6?.file) {
    const formData6 = new FormData()
    formData6.append('resource', previewImages.image6.file)
    formData6.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image6?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData6 }).then(() => {})
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #6: ${err.message}`)
      return false
    }
  }

  if (previewImages.image7?.file) {
    const formData7 = new FormData()
    formData7.append('resource', previewImages.image7.file)
    formData7.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image7?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData7 }).then(() => {})
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #7: ${err.message}`)
      return false
    }
  }

  return true
}

async function handleCreate(
  club,
  links,
  previewImages,
  alreadyCreated,
  setAlreadyCreated,
  saveAndQuit
) {
  if (club.clubName === '' || club.clubId === '')
    return toast.error('Please make sure you have all app information fields filled out.')

  club = {
    ...club,
    logo: `${club.clubId}-${club.logo}`,
    couponbtn: {
      ...club.couponbtn,
      coupondata: {
        ...club.couponbtn.coupondata,
        image1: {
          _text: club.couponbtn.coupondata.image1?._text
            ? `${club.clubId}-${club.couponbtn.coupondata.image1._text}`
            : ''
        },
        image2: {
          _text: club.couponbtn.coupondata.image1?._text
            ? `${club.clubId}-${club.couponbtn.coupondata.image2._text}`
            : ''
        },
        image3: {
          _text: club.couponbtn.coupondata.image1?._text
            ? `${club.clubId}-${club.couponbtn.coupondata.image3._text}`
            : ''
        },
        image4: {
          _text: club.couponbtn.coupondata.image1?._text
            ? `${club.clubId}-${club.couponbtn.coupondata.image4._text}`
            : ''
        },
        image5: {
          _text: club.couponbtn.coupondata.image1?._text
            ? `${club.clubId}-${club.couponbtn.coupondata.image5._text}`
            : ''
        },
        image6: {
          _text: club.couponbtn.coupondata.image1?._text
            ? `${club.clubId}-${club.couponbtn.coupondata.image6._text}`
            : ''
        }
      }
    }
  }

  const xml = convert.json2xml(JSON.stringify(club), {
    compact: true,
    ignoreComment: true,
    spaces: 4,
    ignoreAttributes: '<root>'
  })

  const body = {
    clubName: club.clubName,
    clubId: club.clubId,
    contentxml: xml
  }

  if (!alreadyCreated) {
    uploadImages(previewImages, club).then(uploadResp => {
      if (uploadResp) {
        ClubService.create({ data: body })
          .then(async resp => {
            const clubId = resp.data.id
            await handleSaveCustomLinks(links, clubId)
            setAlreadyCreated(true)
            if (saveAndQuit) navigate('/')
            return toast.info('Successfully saved the client')
          })
          .catch(error => {
            return toast.error(error.message)
          })
      }
    })
  } else {
    uploadImages(previewImages, club).then(uploadResp => {
      if (uploadResp) {
        // Get existing club id from appcode
        ClubService.getId({ appCode: club.clubId }).then(async resp => {
          const clubId = resp.data.id
          ClubService.update({ id: clubId, data: body })
            .then(async () => {
              await handleSaveCustomLinks(links, clubId)
              if (saveAndQuit) navigate('/')
              return toast.info('Successfully saved the client')
            })
            .catch(error => {
              return toast.error(error.message)
            })
        })
      }
    })
  }
}

export default handleCreate
